/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBluetoothX = createReactComponent("bluetooth-x", "IconBluetoothX", [
  ["path", { d: "M7 8l10 8l-5 4v-16l1 .802m0 6.396l-6 4.802", key: "svg-0" }],
  ["path", { d: "M16 6l4 4", key: "svg-1" }],
  ["path", { d: "M20 6l-4 4", key: "svg-2" }]
]);

export { IconBluetoothX as default };
//# sourceMappingURL=IconBluetoothX.js.map
